module.exports = __webpack_public_path__ + "4c128abe0e9fb0cdcd21e1ee91d776cf.svg";